export const aboutInfo = {
  mission: "우리가 사는 인천, 우리가 아름답게",
  vision: "한마음 봉사단은 환경정화 · 나눔봉사 · 재능기부로 따뜻한 지역사회를 만들어갑니다.",
  description:
    "한마음회 봉사단은 인천 지역의 환경 보호와 취약계층 지원, 그리고 시민들의 문화 향유를 위해 노력하는 비영리 자원봉사 단체입니다. 거리의 작은 쓰레기 하나를 줍는 것부터 시작하여, 오늘날 인천시 남동구를 중심으로 다양한 봉사활동과 나눔 행사를 펼치고 있습니다. 모든 회원들의 작은 마음이 모여 더 넓은 사랑과 더 큰 희망을 만드는 것, 그것이 한마음회의 가장 큰 자랑입니다.",
  stats: [
    { label: "설립 연도", value: "2020년" },
    { label: "봉사 회원", value: "300+ 명" },
    { label: "연간 봉사 활동", value: "50+ 회" },
    { label: "누적 봉사 시간", value: "10,000+ 시간" },
  ],
  values: [
    {
      title: "환경정화",
      description:
        "우리가 사는 인천의 거리와 공원을 깨끗하게 정화하여 미래 세대에게 아름다운 환경을 물려줍니다.",
      icon: "ri-plant-line",
    },
    {
      title: "나눔봉사",
      description:
        "복지 사각지대에 놓인 취약계층에게 필요한 도움과 따뜻한 마음을 전하며 이웃사랑을 실천합니다.",
      icon: "ri-hand-heart-line",
    },
    {
      title: "재능기부",
      description:
        "회원들의 다양한 재능을 통해 시민들에게 문화와 배움의 기회를 나누며 풍요로운 지역문화를 만듭니다.",
      icon: "ri-music-2-line",
    },
  ],
  heroImage:
    "https://static.wixstatic.com/media/17b604_4cd3a1e73b624ff5ac0b83b7e4c1e84c~mv2.png/v1/fill/w_1280,h_760,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/17b604_4cd3a1e73b624ff5ac0b83b7e4c1e84c~mv2.png",
};

export const chairmanGreeting = {
  name: "석문숙",
  title: "한마음봉사단 회장",
  image:
    "https://static.readdy.ai/image/309c8cd033c69b13958f82260e1bf6fe/b4c91036712dd34dd5b0ad0f785d5246.png",
  greeting: [
    "안녕하십니까, 한마음봉사단 회장 석문숙입니다.",
    "한마음봉사단은 '우리가 사는 인천, 우리가 아름답게'라는 슬로건 아래, 환경정화, 나눔봉사, 재능기부 세 가지 축을 중심으로 인천 지역사회와 함께 성장하고 있는 자원봉사 단체입니다.",
    "2020년 작은 모임으로 시작한 한마음봉사단은 오늘날 300여 명의 회원들이 함께하며, 인천 대공원 환경정화, 소래찬 김장 나눔, 마음톡톡콘서트 등 다양한 봉사활동과 행사를 통해 지역 주민들과 소통하고 있습니다.",
    "모든 회원들의 작은 실천이 모여 큰 변화를 만들어낸다는 믿음으로, 앞으로도 인천시민과 함께 더 따뜻하고 아름다운 지역사회를 만들어가겠습니다.",
    "여러분의 관심과 참여는 한마음봉사단에게 큰 힘이 됩니다. 함께해 주셔서 감사합니다.",
  ],
  closing: "한마음봉사단 회장 석문숙 드림",
};

export const historyTimeline = [
  {
    year: "2020",
    month: "03월",
    title: "한마음봉사단 창립",
    description:
      "인천시 남동구에서 10명의 회원으로 한마음봉사단을 창립했습니다. 첫 환경정화 활동을 인천 대공원에서 시작했습니다.",
  },
  {
    year: "2020",
    month: "06월",
    title: "장수천 둘레길 환경정화 조성사업 시작",
    description:
      "인천시 남동구청과 협약을 맺고 장수천 둘레길 환경정화 조성사업을 정기적으로 시작했습니다.",
  },
  {
    year: "2021",
    month: "01월",
    title: "남동구청 소래찬 김장 나눔 행사 참여",
    description:
      "매년 진행되는 남동구청 소래찬 김장 나눔 행사에 자원봉사자로 참여하여 지역 어르신들과 취약계층에게 김장 나눔을 시작했습니다.",
  },
  {
    year: "2021",
    month: "06월",
    title: "마음톡톡콘서트 첫 개최",
    description:
      "회원들의 재능을 나누는 '마음톡톡콘서트'를 처음 개최하였고, 지역 주민들에게 큰 호응을 얻었습니다.",
  },
  {
    year: "2022",
    month: "09월",
    title: "인천시 자원봉사단체 등록",
    description:
      "인천시 자원봉사센터에 정식 자원봉사단체로 등록되었습니다. 봉사 활동 범위를 전 인천 지역으로 확대했습니다.",
  },
  {
    year: "2022",
    month: "12월",
    title: "누적 봉사 시간 5,000시간 돌파",
    description:
      "창립 2년 만에 누적 자원봉사 시간 5,000시간을 돌파하며, 인천 지역사회에 꾸준한 기여를 인정받았습니다.",
  },
  {
    year: "2023",
    month: "04월",
    title: "회원 200명 돌파 및 정기 모임 체계화",
    description:
      "회원 수 200명을 돌파하며 한마음 정기 모임 체계를 정비하고, 환경정화, 나눔, 재능기부 세 가지 팀으로 사업을 전문화했습니다.",
  },
  {
    year: "2023",
    month: "11월",
    title: "이제는 행복할 차례 음악 토크 콘서트 개최",
    description:
      "새로운 재능나눔 프로그램 '이제는 행복할 차례' 음악 토크 콘서트를 성공적으로 개최했습니다.",
  },
  {
    year: "2024",
    month: "03월",
    title: "회원 300명 돌파 및 웹사이트 개편",
    description:
      "회원 수 300명을 돌파하며 봉사단의 대외 홍보를 위해 공식 웹사이트를 새롭게 개편했습니다.",
  },
  {
    year: "2024",
    month: "10월",
    title: "인천 대공원 연합 봉사활동 확대",
    description:
      "인천시 자원봉사단체 연합과 협력하여 인천 대공원 대규모 연합 봉사활동을 확대 진행했습니다.",
  },
  {
    year: "2025",
    month: "05월",
    title: "누적 봉사 시간 10,000시간 돌파",
    description:
      "창립 5년 만에 누적 자원봉사 시간 10,000시간을 달성했습니다. 앞으로도 지속 가능한 봉사문화를 이어가겠습니다.",
  },
];